module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAABZklEQVQ4T52TwSsEYRjGf++YmVI4CQcHidpy44CbxMEfsEnJgdmDNgdHpThwlxxkJ6ktObg5KA4uckDKhZKDm4uLouzM7Lzatavd2R3hO37P8/y+5/2+PuGHlXdI50PO7V1u42wSJ+gszYHBI3BjuUz8GeA7rCqsFIISMmrtclYPUrfBm0O7TfH0plLo0nYZ/DXAc9gC0pUBA5Kmy2EUUtPgY44eQ7gDrIj5weqkT1YJKvdrAJ7DATBZMIUhCUMYQtgrhoR5O8N2LMBzGEC5QiiCrYDGoIERFY6/8jybOXoly3sZUtXAT3GqylhZjAJKkGXLZb0G4DuMK5xU1VPWVOgCpisCr6ZBj+zwUgKCgvgprlH6qy5OyIrSoTAeudAN22XxG5BzmBLYjz5RvRFKnlzeJNG4zZNoEttv4R6hOwpQOBKlFWE4qhlC1swwI16KBZTNH/5UnBQS0l+YfUmVtn8AMAwuPgGQTWhS7YXbuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/warning - icon.png
// module id = oeHC
// module chunks = 11